import { useMemo } from "react";
import { createCollectionStore } from "../../../shared/data/createCollectionStore.js";
import {
  getCompanies,
  createCompany,
  updateCompany,
  deleteCompany,
  setDefaultCompany
} from "../services/companyService.js";

// One shared, cached list of companies for every screen, so a change made in Settings
// (name, default, numbering) shows at once in the header, branding and bill screens.
export const companyStore = createCollectionStore(getCompanies, {
  errorMessage: "Unable to load company profiles."
});

export function useCompanies() {
  const { data: companies, loading, error } = companyStore.useStore();
  const fetchCompanies = companyStore.refresh;

  const defaultCompany = useMemo(() => {
    if (companies.length === 0) return null;
    return companies.find((c) => c.isDefault) || companies[0];
  }, [companies]);

  const addCompany = async (companyData) => {
    const id = await createCompany(companyData);
    await fetchCompanies();
    return id;
  };

  const editCompany = async (id, companyData) => {
    await updateCompany(id, companyData);
    await fetchCompanies();
  };

  const removeCompany = async (id) => {
    await deleteCompany(id);
    await fetchCompanies();
  };

  const setAsDefault = async (id) => {
    await setDefaultCompany(id);
    await fetchCompanies();
  };

  return {
    companies,
    defaultCompany,
    loading,
    error,
    refetch: fetchCompanies,
    addCompany,
    editCompany,
    removeCompany,
    setAsDefault
  };
}

export default useCompanies;
